import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";
import { Button } from "./button";

const fabVariants = cva(
  "fixed z-40 size-14 rounded-full shadow-lg",
  {
    defaultVariants: {
      position: "bottom-right",
    },
    variants: {
      position: {
        "bottom-right": "right-4 bottom-6",
        "bottom-center": "-translate-x-1/2 bottom-6 left-1/2",
      },
    },
  },
);

function Fab({
  className,
  position,
  ...props
}: Omit<React.ComponentProps<typeof Button>, "size"> & VariantProps<typeof fabVariants>) {
  return (
    <Button
      className={cn(fabVariants({ position }), className)}
      data-slot="fab"
      size="icon-xl"
      {...props}
    />
  );
}

export { Fab, fabVariants };
